export default __webpack_public_path__ + "static/media/hero-video-compressed-new.9bd0ce28.webm";